import {
  AssignmentFragment,
  AssignmentsQuery,
  AssignmentTypeEnum,
} from '@school_ify/schoolify-repository/src/shared/types';
import {
  teacherCreateAssignment,
  teacherGetAssignmentStudentsGrades,
} from '@school_ify/schoolify-repository/src/teacher/repositories/assignmentRepository';
import { getAssignments } from '@school_ify/schoolify-repository/src/shared/repositories/assignmentRepository';
import {
  TeacherAssignmentInsertMutationVariables,
  TeacherAssignmentStudentGradesQueryVariables,
  TeacherGradeUpdateMarkMutationVariables,
} from '@school_ify/schoolify-repository/src/teacher/types';
import { teacherUpdateGradeMark } from '@school_ify/schoolify-repository/src/teacher/repositories/gradeRepository';
import { studentOrTeacherToggleAssignment } from '@school_ify/schoolify-repository/src/student_teacher/repositories/assignmentRepository';
import { StudentOrTeacherAssignmentToggleMutationVariables } from '@school_ify/schoolify-repository/src/student_teacher/types';

export interface SingleAssignmentsInterface {
  readonly id?: string;
  readonly title?: string;
  readonly description?: string;
  readonly duration?: number;
  readonly is_gradeable?: boolean;
  readonly teacher_is_completed?: boolean;
  readonly due_at?: string;
  readonly submited_by?: any;
  readonly assignment_type?: { readonly name: string; readonly icon?: string };
}

interface groupByDateInterface {
  overdue: SingleAssignmentsInterface[];
  today: SingleAssignmentsInterface[];
  tomorrow: SingleAssignmentsInterface[];
}

class AssignmentsService {
  public checkForSameDate(d1: Date, d2: Date) {
    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    );
  }

  public async getAssignments(arg: any): Promise<AssignmentsQuery | undefined> {
    try {
      const data = await getAssignments(arg);
      return data;
    } catch (err) {
      throw new Error(`Teacher assignment error: ${err}`);
    }
  }

  // TODO ask sebi to add interface just for singleAssignment - without totalCount
  public groupByDate(assignments: AssignmentsQuery | any): groupByDateInterface {
    const today = new Date();
    const lessons: groupByDateInterface = {
      overdue: [],
      today: [],
      tomorrow: [],
    };

    assignments.assignments.forEach((singleAssignment: SingleAssignmentsInterface) => {
      const assignmentDate = new Date(singleAssignment.due_at);

      // if (assignmentDate === today) lessons.today.push(singleAssignment);
      if (this.checkForSameDate(assignmentDate, today)) lessons.today.push(singleAssignment);
      else if (assignmentDate < today) lessons.overdue.push(singleAssignment);
      else lessons.tomorrow.push(singleAssignment);
    });

    return lessons;
  }

  public async addAssignment(
    variable: TeacherAssignmentInsertMutationVariables
  ): Promise<Readonly<AssignmentFragment>> {
    try {
      const muation = await teacherCreateAssignment(variable);
      return muation;
    } catch (err) {
      throw new Error(`Teacher adding assignment error: ${err}`);
    }
  }

  public getAssignmentTypes(): AssignmentTypeEnum[] {
    return [
      AssignmentTypeEnum.HAUSAUFGABE,
      AssignmentTypeEnum.KLASSENARBEIT,
      AssignmentTypeEnum.PRUFUNG,
      AssignmentTypeEnum.ONLINE,
    ];
  }

  public async getTeacherCassStudentsQuery(assignment_id) {
    const arg: TeacherAssignmentStudentGradesQueryVariables = {
      assignment_id,
    };
    try {
      const data = await teacherGetAssignmentStudentsGrades(arg);
      return data;
    } catch (err) {
      throw new Error(`Teacher getting student for a assignment error: ${err}`);
    }
  }

  public async updateStudentMark(data: TeacherGradeUpdateMarkMutationVariables) {
    try {
      const success = await teacherUpdateGradeMark(data);
      return success;
    } catch (err) {
      throw new Error(`Update student mark grade: ${err}`);
    }
  }

  // teacherCompleteAssignment
  public async toggleTeacherAssignment(data: StudentOrTeacherAssignmentToggleMutationVariables) {
    try {
      await studentOrTeacherToggleAssignment(data);
    } catch (err) {
      throw new Error(`Update student mark grade: ${err}`);
    }
  }
}

export default new AssignmentsService();
